import { render, staticRenderFns } from "./PregledZaposlenih.vue?vue&type=template&id=004f87a4&scoped=true&"
import script from "./PregledZaposlenih.vue?vue&type=script&lang=ts&"
export * from "./PregledZaposlenih.vue?vue&type=script&lang=ts&"
import style0 from "./PregledZaposlenih.vue?vue&type=style&index=0&id=004f87a4&scoped=true&lang=css&"
import style1 from "./PregledZaposlenih.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f87a4",
  null
  
)

export default component.exports